import { Component, OnInit, AfterViewInit } from "@angular/core";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
  UntypedFormArray,
  UntypedFormGroup,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VproService } from "src/app/service/vpro/vpro.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { Location } from "@angular/common";
import { formatDate } from "@angular/common";
import {
  NgbDatepickerConfig,
  NgbDate,
  NgbCalendar,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { any } from "underscore";
import { uid } from "chart.js/dist/helpers/helpers.core";

declare var $: any;

@Component({
  selector: "app-patient-edit-profile",
  templateUrl: "./patient-edit-profile.component.html",
  styleUrls: ["./patient-edit-profile.component.css"],
})
export class PatientEditProfileComponent implements OnInit {

  freqList = [
    {
      id: 1,
      value: "Daily",
    },
    {
      id: 2,
      value: "Weekly",
    },
    {
      id: 3,
      value: "Monthly",
    },
    {
      id: 4,
      value: "Yearly",
    },
  ];
  editCurrentTab: string = "medicalInformation";
  editCurrentTabs: string[] = ["personalInformation", "medicalInformation"];
  editListOfTabs: string[] = ["personalInformation", "medicalInformation"];
  forms = {
    personalInformation: null,
    medicalInformation: null,
    allergyform: null
  };
  user: any;
  physician: any;
  allergy: any;
  yearList: any[];
  patient: any;
  current_medication: UntypedFormArray;
  appetite_habbitsList: any = [];
  patient_med_history: UntypedFormArray;
  patient_medication: UntypedFormArray;
  patient_appetite: UntypedFormArray;
  patient_lifestyle: UntypedFormArray;
  patient_fmed_history: UntypedFormArray;
  diseaseList: any = [];
  patient_appHabbitsList: any = [];
  displayNames: any = {
    pmed_dose: "Drug Name",
    pmed_freq: "Frequency",
    habbit: "Habbit",
    disease: "Disease Name",
    duration: "Duration",
    //med_hist_year: "X",
    med_hist_info: "Add Information",
    disease_id: "Disease Name",
    habit_details: "consuming qty",
    frequency: "Frequency",
    since: " ",
    habit_id: "Add Habbit",
    remarks: "Deceased Reason",
    status: "is alive",
    freq: "activity frequency",
  };

  ppfile: File = null;
  isEdited: boolean = false;
  maxDate = Utils.today;
  minDate = Utils.minDobDate;
  gender = Utils.GENDER;
  blood_group = Utils.BLOODGROUP;
  state = Utils.STATE;
  habit_st: any;
  currentDate = Utils.maxDate;
  miniDate = Utils.miniDate;
  avatartimg: any;
  patientname: string;
  displayAllergybox: boolean = false;
  u_id = localStorage.getItem('uid');
  currentdt = Utils.maxDate;
  cdt = `${this.currentdt.year}-${this.currentdt.month}-${this.currentdt.day}`;
  rec_data: string;
  physicanname: any;
  uby: string;
  cby: string;
  creatername: string;
  updatername: string;
  username: string;
  updatedat: string;
  createdat: string;
  createdby: any;
  updatedby: any;

  constructor(
    config: NgbDatepickerConfig,
    calendar: NgbCalendar,
    private router: Router,
    private service: VproService,
    private route: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private location: Location
  ) {

    this.forms.allergyform = this._formBuilder.group({
      allergy: [null],
    });

    this.forms.personalInformation = this._formBuilder.group({
      address_1: [null, [Validators.maxLength(150)]],
      address_2: [null, [Validators.maxLength(150)]],
      u_id: [null],
      city_n: [null, [Validators.maxLength(30)]],
      contact_no: [
        null,
        [
          Validators.pattern(Utils.numberRegex),
          Validators.maxLength(12),
          Validators.minLength(10),
        ],
      ],
      zip: [
        null,
        [
          Validators.pattern(Utils.numberRegex),
          Validators.maxLength(6),
          Validators.minLength(6),
        ],
      ],
      ppurl: [null],
      pp_content_type: [null],
      email_id: [
        "",
        [
          Validators.required,
          Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/),
          Validators.maxLength(30),
        ],
      ],
      gender: [null],
      blood_group: [null],
      state: [null],
      height: ["", [Validators.pattern(/^[0-9]+$/)]],
      weight: ["", [Validators.pattern(/^[0-9]+$/)]],
      dob: ["", Validators.required],
      updatedby: this.u_id,
      updatedat: this.cdt
    });

    this.forms.medicalInformation = this._formBuilder.group({
      patient_med_history: this._formBuilder.array([]),
      patient_medication: this._formBuilder.array([]),
      patient_appetite: this._formBuilder.array([]),
      patient_lifestyle: this._formBuilder.array([]),
      patient_fmed_history: this._formBuilder.array([]),
    });

  }

  ngOnInit() {
    this.loadPatient();
    this.getDiseaseList();
    this.getAppHabbitList();
    this.addPatfmedhistory();
    this.getYears();

    $("#datetimepicker1").datetimepicker({
      inline: true,
      sideBySide: true,
    });
  }



  // loadUser(uid) {
  //   this.spinner.show();
  //   this.service.getFrontDeskById(uid).subscribe(
  //     (response) => {
  //       this.spinner.hide();
  //       if (response) {
  //         this.user = response;

  //         let username = this.user.first_name + " " + this.user.last_name;
  //         console.log(username);
  //         return username;


  //       }
  //     },
  //     (error) => {
  //       this.spinner.hide();
  //       const Toast = Swal.mixin({
  //         toast: true,
  //         position: "top",
  //         showConfirmButton: false,
  //         timer: 3500,
  //       });
  //       Toast.fire({
  //         type: "error",
  //         title: "Something went wrong. Please try again later.",
  //       });
  //     }
  //   );
  // }

  async loadUser(uid): Promise<string> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      this.service.getFrontDeskById(uid).subscribe(
        async (response) => {
          this.spinner.hide();
          if (response) {
            this.user = await response; // Assuming this is also async; otherwise, remove `await`
            let username = this.user.first_name + " " + this.user.last_name;
            console.log(username);
            resolve(username); // Resolve the promise with the username
          } else {
            // Consider rejecting or resolving with a default/empty value if no response
            reject('No response');
          }
        },
        (error) => {
          this.spinner.hide();
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });
          Toast.fire({
            type: "error",
            title: "Something went wrong. Please try again later.",
          });
          reject(error); // Reject the promise on error
        }
      );
    });
  }
  checkValue(event: any) {
    if (event == false) {
      this.forms.allergyform = this._formBuilder.group({
        allergy: [null],
      });
    }
  }
  loadPatient() {
    this.spinner.show();
    this.service.fetchPatientById(this.route.snapshot.params["id"]).subscribe(
      async (response) => {
        this.spinner.hide();
        if (response) {
          console.log("PATIENT RESPONSE", response)
          this.patient = response;
          let startDate = this.patient.dob.split('-');
          this.forms.personalInformation.patchValue({
            dob: { year: parseInt(startDate[0]), month: parseInt(startDate[1]), day: parseInt(startDate[2]) }
          })
          // if (this.patient && this.patient.dob) this.patchVal(this.patient.dob);
          // //  Retain form values upon click
          // this.forms.personalInformation.patchValue(this.patient);

          this.patientname = this.patient.first_name + ' ' + this.patient.last_name;
          console.log("patientname", this.patientname);
          this.avatartimg = this.patient.ppurl.substring(this.patient.ppurl.lastIndexOf('/') + 1);
          console.log("this.physician.ppurl", this.avatartimg);
          if (this.avatartimg == "img_avatar.png")
            this.patient.ppurl = ""

          if (this.patient.allergy != null) {
            this.displayAllergybox = true;
          }

          /* ------------------------------------------------------*/

          if (this.patient.createdat) {
            const isoDateStringC: string = this.patient.createdat;
            const cdate: Date = new Date(isoDateStringC);
            this.createdat = cdate.getDate() + "/" + (cdate.getMonth() + 1) + "/" + cdate.getFullYear();
          } else this.createdat == "";


          if (this.patient.updatedat) {
            const isoDateStringU: string = this.patient.updatedat;
            const udate: Date = new Date(isoDateStringU);
            this.updatedat = udate.getDate() + "/" + (udate.getMonth() + 1) + "/" + udate.getFullYear();
          } else this.updatedat == "";
          /* ------------------------------------------------------*/


          try {
            if (this.patient?.createdby !== null) {
              this.createdby = await this.loadUser(this.patient?.createdby);
            }
            if (this.patient?.updatedby !== null) {
              this.updatedby = await this.loadUser(this.patient?.updatedby);
            }
          } catch (error) {
            console.error('Failed to load user:', error);
          }

          console.log("cretaedby", this.createdby);
          this.patchValallergy();
          this.addHistory();
          this.addMedication();
          this.addAppetite();
          this.addLifestyle();
          this.addPatfmedhistory();
        }
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }

  getGender(g_key) {
    for (let r of this.gender) {
      if (r.key === g_key) return r.value;
    }
  }

  getBloodgroup(g_key) {
    for (let r of this.blood_group) {
      if (r.key === g_key) return r.value;
    }
  }

  getState(g_key) {
    for (let r of this.state) {
      if (r.key === g_key) return r.value;
    }
  }

  patchValallergy() {
    console.log("patch Valueeeeeeeeeeeeeee", this.patient.allergy);

    this.forms["allergyform"].patchValue({ allergy: this.patient.allergy })
  }
  patchVal(val) {
    if (val.dob) {
      let dob = val.dob.split("-");
      this.forms["personalInformation"].patchValue({
        dob: {
          year: parseInt(dob[0]),
          month: parseInt(dob[1]),
          day: parseInt(dob[2]),
        },
      });
    }
  }

  getControl(field: string): UntypedFormControl {

    if (field == "patient_medication" || field == "patient_appetite" || field == "patient_med_history" || field == "patient_lifestyle" || field == "patient_fmed_history") {
      return this.forms[this.editCurrentTabs[1]].get(field) as UntypedFormControl;
    } else if (field == "allergy") {
      return this.forms["allergyform"].get(field) as UntypedFormControl;
    } else {

      return this.forms[this.editCurrentTabs[0]].get(field) as UntypedFormControl;
    }
    // return this.forms[this.editCurrentTab].get(field) as UntypedFormControl;
  }

  getAppHabbitList() {
    this.service.getAppHabbitList().subscribe((res) => {
      this.patient_appHabbitsList = res;
    });
  }

  getDiseaseList() {
    this.service.getDiseaseList().subscribe((res) => {
      this.diseaseList = res;
    });
  }

  createHistory(id, years, info, createdby, createdat): UntypedFormGroup {
    return this._formBuilder.group({
      disease_id: [id, [Validators.required]],
      // med_hist_year: [years, [Validators.required]],
      med_hist_info: [info],
      since: [years, [Validators.required]],
      createdby: [createdby],
      createdat: [createdat],
      updatedby: [this.u_id],
      updatedat: [this.cdt]
    });
  }

  createMedication(pmed_dose, pmed_freq, since, createdby, createdat): UntypedFormGroup {
    return this._formBuilder.group({
      pmed_dose: [pmed_dose],
      pmed_freq: [pmed_freq],
      since: [since],
      createdby: [createdby],
      createdat: [createdat],
      updatedby: [this.u_id],
      updatedat: [this.cdt]
    });
  }

  createApetite(habit_id, habit_details, has_habit, frequency, since, createdby, createdat): UntypedFormGroup {
    return this._formBuilder.group({
      habit_details: [habit_details],
      habit_id: [habit_id],
      has_habit: [has_habit],
      frequency: [frequency],
      since: [since],
      createdby: [createdby],
      createdat: [createdat],
      updatedby: [this.u_id],
      updatedat: [this.cdt]
    });
  }

  createLifestyle(activity, duration, freq, createdby, createdat): UntypedFormGroup {
    return this._formBuilder.group({
      activity: [activity],
      duration: [duration],
      freq: [freq],
      createdby: [createdby],
      createdat: [createdat],
      updatedby: [this.u_id],
      updatedat: [this.cdt]
    });
  }


  createPatfmedhistory(relation, diabetic, cardio, tension, cholestral, status, remarks, createdby, createdat): UntypedFormGroup {
    return this._formBuilder.group({
      relation: [relation],
      diabetic: [diabetic],
      tension: [tension],
      cholestral: [cholestral],
      cardio: [cardio],
      status: [status],
      remarks: [remarks],
      createdby: [createdby],
      createdat: [createdat],
      updatedby: [this.u_id],
      updatedat: [this.cdt]
    });
  }


  addHistory() {
    if (this.patient && this.patient.patient_med_history) {
      for (let item of this.patient.patient_med_history) {
        this.patient_med_history = this.forms.medicalInformation.get(
          "patient_med_history"
        ) as UntypedFormArray;
        this.patient_med_history.push(
          this.createHistory(
            item.disease_id,
            item.since,
            item.med_hist_info,
            item.createdby,
            item.createdat,
          )
        );
      }
    }
  }

  addMedication() {
    if (this.patient && this.patient.patient_medication) {
      for (let item of this.patient.patient_medication) {
        this.patient_medication = this.forms.medicalInformation.get(
          "patient_medication"
        ) as UntypedFormArray;
        this.patient_medication.push(
          this.createMedication(item.pmed_dose, item.pmed_freq, item.since, item.createdby, item.createdat)
        );
      }
    }
  }

  addLifestyle() {
    if (this.patient && this.patient.patient_lifestyle) {
      for (let item of this.patient.patient_lifestyle) {
        this.patient_lifestyle = this.forms.medicalInformation.get(
          "patient_lifestyle"
        ) as UntypedFormArray;
        this.patient_lifestyle.push(
          this.createLifestyle(item.activity, item.duration, item.freq, item.createdby, item.createdat)
        );
      }
    }
  }

  addPatfmedhistory() {
    if (this.patient && this.patient.patient_fmed_history) {
      for (let item of this.patient.patient_fmed_history) {
        this.patient_fmed_history = this.forms.medicalInformation.get(
          "patient_fmed_history"
        ) as UntypedFormArray;
        this.patient_fmed_history.push(
          this.createPatfmedhistory(item.relation, item.diabetic, item.cardio, item.tension, item.cholestral, item.status, item.remarks, item.createdby, item.createdat)
        );
      }
    }
  }

  addAppetite() {
    if (this.patient && this.patient.patient_appetite) {
      for (let item of this.patient.patient_appetite) {
        this.patient_appetite = this.forms.medicalInformation.get(
          "patient_appetite"
        ) as UntypedFormArray;
        this.patient_appetite.push(
          this.createApetite(item.habit_id, item.habit_details, item.has_habit, item.frequency, item.since, item.createdby, item.createdat)
        );
      }
    }
  }

  /** assign tabs based on click */
  public editAssignTab(tabName: string): void {
    this.editCurrentTab = tabName;
  }

  /** next tabs based on next click by user */
  public editNextTab(): void {
    let index = this.editListOfTabs.indexOf(this.editCurrentTab);
    this.editCurrentTab = this.editListOfTabs[index + 1];
  }
  /** get previous tabname and info */
  public editPreviousTab(): void {
    let index = this.editListOfTabs.indexOf(this.editCurrentTab);
    this.editCurrentTab = this.editListOfTabs[index - 1];
  }

  updateField(field: string) {
    const control = this.getControl(field);
    console.log("field", field);
    console.log("control", control);

    if (control.valid) {
      this.patient = {
        ...this.patient,
        [field]: control.value,
      };
    }
    console.log("this.patient", this.patient);
  }

  public fileSelected(event) {
    if (
      (event.target.files[0].type &&
        event.target.files[0].type.indexOf("image") === -1) ||
      !Utils.allowedImageFormats.includes(
        event.target.files[0].type.split("/").pop()
      )
    ) {
      const Toast = Swal.mixin({
        position: "top",
        showConfirmButton: true,
        allowOutsideClick: false,
      });

      Toast.fire({
        type: "warning",
        title: "Only .png/.jpeg/.jpg format is allowed",
      });
    } else {
      if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();

        reader.readAsDataURL(event.target.files[0]); // read file as data url

        reader.onload = (e: Event) => {
          // called once readAsDataURL is completed
          if (e && e.target && e.target["result"]) {
            this.patient.ppurl = e.target["result"];
          }
        };

        // now update ppurl file to send in api
        this.ppfile = event.target.files[0];
        this.forms.personalInformation.patchValue({
          ppurl: event.target.files[0].name,
          pp_content_type: event.target.files[0].type,
        });

        this.isEdited = true;
      }
    }
  }

  updatePatient() {
    let data = {
      ...this.forms.personalInformation.value,
      ...this.forms.allergyform.value,
      ...this.forms.medicalInformation.value,
    };


    console.log("...this.forms.personalInformation.value,", data,)
    // Remove any empy fields
    data = Utils.removeNullAndEmpty(data);
    if (!this.isEdited) {
      delete data.ppurl;
      delete data.pp_content_type;
    }
    if (data.patient_med_history && data.patient_med_history.length > 0) {
      // console.log("before removeNullandEmpty", data.patient_med_history);
      data.patient_med_history.forEach((x, index) => {
        data.patient_med_history[index] = Utils.removeNullAndEmpty(
          data.patient_med_history[index]
        );


        if (data.patient_med_history[index].disease_id != null && data.patient_med_history[index].med_hist_info == null && data.patient_med_history[index].since == null) {

          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });
          Toast.fire({
            type: "error",
            title: "Some field are Missing in Medical History",
          });
          data = null;
          return null;
        }
      });
      // console.log("after removeNullandEmpty", data.patient_med_history);
      data.patient_med_history = data.patient_med_history.filter(
        (x) => x.disease_id || x.med_hist_info
      );
      // console.log("data.patient_med_history ::after filter", data.patient_med_history);

    }

    if (data.patient_medication && data.patient_medication.length > 0) {
      data.patient_medication.forEach((x, index) => {
        data.patient_medication[index] = Utils.removeNullAndEmpty(
          data.patient_medication[index]
        );
      });
      data.patient_medication = data.patient_medication.filter(
        (x) => x.pmed_dose || x.pmed_freq || x.since
      );
    }
    if (data.patient_appetite && data.patient_appetite.length > 0) {
      data.patient_appetite.forEach((x, index) => {

        if (x.since === '') {
          console.log("since is empty");
          x.since = 0;
          //delete (x.since)
        }
        console.log("x.since", x.since)
        // x.ap_date = current_date;
        data.patient_appetite[index] = Utils.removeNullAndUndefined(
          data.patient_appetite[index]
        );
      });
    }
    // if (data.patient_appetite && data.patient_appetite.length > 0) {
    //   data.patient_appetite.forEach((x, index) => {
    //     data.patient_appetite[index] = Utils.removeNullAndUndefined(
    //       data.patient_appetite[index]
    //     );
    //     console.log("x.since", x.since)
    //     if (x.since === '') {
    //       console.log("since is empty");
    //       x.since = 0;
    //       //delete (x.since)
    //     }


    //   });
    // }

    if (data.patient_appetite && data.patient_appetite.length === 0) {
      delete data.patient_appetite;
    }
    if (data.patient_medication && data.patient_medication.length === 0) {
      delete data.patient_medication;
    }
    if (data.patient_med_history && data.patient_med_history.length === 0) {
      delete data.patient_med_history;
    }

    let dob_date = [data.dob.year, data.dob.month, data.dob.day].join("-")
    if (dob_date) {
      data.dob = formatDate(dob_date, "yyyy-MM-dd", "en-US");
    }
    if (data.gender) {
      data.gender = data.gender.toLowerCase();
    }
    if (data.blood_group) {
      data.blood_group = data.blood_group.toLowerCase();
    }
    if (data.state) {
      data.state = data.state.toLowerCase();
    }


    data["pid"] = this.route.snapshot.params["id"];
    data["org_code"] = localStorage.getItem("orgcode");
    this.spinner.show();
    // console.log("DATA", data);
    this.service
      .newupdatePatient(this.route.snapshot.params["id"], data, this.ppfile)
      .subscribe(
        (res) => {
          this.spinner.hide();
          // SweetAlert

          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });
          this.router.navigate(["/profile"]);
          Toast.fire({
            type: "success",
            title: "Patient profile has been updated successfuly",
          });
        },
        (error) => {
          this.spinner.hide();
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });
          Toast.fire({
            type: "error",
            title: "Something went wrong. Please try again later.",
          });
        }
      );
  }

  // get f() {
  //   return this.forms[this.editCurrentTab].controls;
  // }

  public showFormArrayVal(index, arrayName, key) {
    let val;
    val = this[arrayName].value[index][key];
    if (arrayName === "patient_med_history" && key === "disease_id") {
      this.diseaseList.forEach((element) => {
        if (element.id == val) {
          val = element.disease_name;
        }
      });
    }

    if (arrayName === "patient_appetite" && key === "habit_id") {
      if (this.patient_appHabbitsList[val - 1]) {
        val = this.patient_appHabbitsList[val - 1].description;
      }
    }



    if (key === "since" && val === 0) {
      this[arrayName].value[index][key] = "0";
      val = "0";
      return val;
    } else if (key === "since" && val === null) {
      val = this.displayNames[key];
    }

    if (!val && key != "since") {
      val = this.displayNames[key];
    }

    return val;
  }

  formValidation(i, key, arrayName) {
    let error = false;
    if (
      this.forms["medicalInformation"].get([arrayName]).controls[i] &&
      this.forms["medicalInformation"].get([arrayName]).controls[i].controls[
      key
      ] &&
      this.forms["medicalInformation"].get([arrayName]).controls[i].controls[
        key
      ].errors
    ) {
      error = true;
    }
    return error;
  }

  addNewFormArray(arrayName) {
    this[arrayName] = this.forms[this.editCurrentTab].get([
      arrayName,
    ]) as UntypedFormArray;

    if (arrayName === "patient_med_history") {
      this[arrayName].push(this.createHistory(null, null, null, null, null));
    }
    if (arrayName === "patient_medication") {
      this[arrayName].push(this.createMedication(null, null, null, null, null));
    }
    if (arrayName === "patient_appetite") {
      this[arrayName].push(this.createApetite(null, null, null, null, null, null, null));
    }
    if (arrayName === "patient_lifestyle") {
      this[arrayName].push(this.createLifestyle(null, null, null, null, null));
    }
    if (arrayName === "patient_lifestyle") {
      this[arrayName].push(this.createPatfmedhistory(null, null, null, null, null, null, null, null, null));
    }
  }

  isSelected(disease_id) {
    return this.forms.medicalInformation
      .get("patient_med_history")
      .value.find((item) => disease_id === item.disease_id);
  }

  public removeFromList(list, i) {
    this[list].removeAt(i);
  }

  getback() {
    this.location.back();
  }

  checkedNo(evt, i) {
    this.patient.patient_appetite[i].has_habit = false;
    console.log(
      "false as has_habit",
      this.patient.patient_appetite[i].has_habit
    );
    // console.log("patient info", this.patient.patient_appetite);
  }

  checkedYes(evt, i) {
    this.patient.patient_appetite[i].has_habit = true;
    console.log(
      "true as has_habit",
      this.patient.patient_appetite[i].has_habit
    );
    this.habit_st = this.patient.patient_appetite[i].has_habit;
    // console.log("patient info", this.patient.patient_appetite);
  }

  public getYears() {
    const resultArray = [];

    for (let i = 1900; i <= (new Date()).getFullYear(); i++) {
      resultArray.push(i);
    }
    this.yearList = resultArray.reverse();
    console.log(this.yearList);
  }

}
